import {withButton} from './withButton';
import {ButtonStyle} from './ButtonStyle';

// TODO: WIP: NOT READY TO BE USED
/** @component */
export const Button = withButton(ButtonStyle);
